import emailjs from 'emailjs-com';
import React, { useState } from 'react';
import './Contact.css';
// Make sure Font Awesome is available in your project
// You can add this to public/index.html inside <head>:
// <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [consent, setConsent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    if (!consent) {
      alert('Please agree to receive text messages.');
      return;
    }
    setLoading(true);
    emailjs
      .sendForm('service_r0plfhi', 'template_u09h6hd', e.target, 'user_kftkAVN4w3dLOjj83aAtF')
      .then(
        (result) => {
          console.log(result.text);
          e.target.reset();
          setConsent(false);
          alert('Message sent successfully!');
        },
        (error) => {
          console.log(error.text);
          alert('Failed to send message.');
        }
      )
      .finally(() => setLoading(false));
  };

  return (
    <section id="Contact" className="contact-section">
      <div className="contact-container">
        
        {/* Contact Info Section */}
        <div className="contact-info">
          <h2>Contact Us</h2>
          <p>Drop us a message if you have any questions, we always try to get back to you within 24 hours.</p>
          <div className="address-block">
            <p><strong>Address:</strong> 8301 State Line Rd. Ste 220 #3291, Kansas City, MO 64114</p>
            <p><strong>Phone Number:</strong> (816) 300-1814</p>
            <p><strong>Email:</strong> info@pristinemaintenance.us⁠</p>
          </div>

          {/* Payment Methods */}
          <div className="payment-methods">
            <h3>Payment Partner</h3>
            <div className="payment-icons">
              <i className="fab fa-cc-visa fa-3x" title="Visa"></i>
              <i className="fab fa-cc-mastercard fa-3x" title="MasterCard"></i>
              <i className="fab fa-cc-stripe fa-3x" title="Stripe"></i>
              <i className="fab fa-cc-paypal fa-3x" title="PayPal"></i>
              
            </div>
          </div>
          <div className="Social-Media">
            <h3>Social Media</h3>
            <div className="payment-icons">
              <a href='' target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-facebook-f fa-4x"></i></a>
              
            </div>
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="contact-form-wrapper">
          <form onSubmit={sendEmail} className="contact-form">
            <div className="row">
              <div className="col">
                <input type="text" name="first_name" placeholder="First name" required />
              </div>
              <div className="col">
                <input type="text" name="last_name" placeholder="Last name" required />
              </div>
            </div>
            <input type="text" name="company" placeholder="Company" />
            <input type="email" name="email" placeholder="Email" required />
            <input type="tel" name="phone" placeholder="Phone number" required />

            <textarea name="message" rows="5" placeholder="Message" required />

            <div className="consent">
              <input
                type="checkbox"
                id="consent"
                checked={consent}
                onChange={() => setConsent(!consent)}
              />
              <label htmlFor="consent">
                I agree to receive text messages (SMS) from Zeven Home Solutions LLC LLC at the phone number
                provided. I understand consent is not a condition of any purchase. Reply STOP to
                cancel, HELP for help. See our <a href="/privacypolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a> <br /> <a href="/privacy.html" target="_blank" rel="noopener noreferrer">Terms & Conditions</a> <br />
                <a href="/refund.html" target="_blank" rel="noopener noreferrer">Refund Policy</a>
              </label>
            </div>

            <button type="submit" disabled={loading}>
              {loading ? 'Sending…' : "Let's talk"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};


export default Contact;
